import { notify } from '@affine/component';
import { mapWorkspaceContextIssueToMessageKey } from '@affine/core/modules/streamlain/copilot/workspace-context-messages';
import { I18n } from '@affine/i18n';

import {
  type ChatPanelHostScope,
  setChatPanelOverlayVisible,
} from './chat-panel-host-registry';

/** Standard 024 errors; no alternative host or route on failure. */
/** The Copilot of a view: a press there is a press in the chat. */
export const WORKSPACE_COPILOT_SELECTOR = '[data-workspace-copilot]';

export function showWorkspaceCopilot(
  scope: ChatPanelHostScope,
  visible = true
) {
  const result = setChatPanelOverlayVisible(scope, visible);
  if (!result.ok) {
    notify.error({
      title: I18n.t(
        mapWorkspaceContextIssueToMessageKey(
          result.reason === 'inactive-view' ? 'stale' : 'unavailable'
        )
      ),
    });
  }
  return result;
}
